module.exports = __webpack_public_path__ + "img/mundozac.a97568b5.png";